import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const getOrderNotification = (id, storeId, orderId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/notification', // for android use
    headers: getHeaders(),
  });
};
